import { totalPages } from "containers/gstr7/GSTR7Summary/actions";
import {
  CHECKED_RUN_FY,
  LOADER_STATUS,
  PROFILE_DATA,
  SAVE_TOTAL_PAGES,
  SELECTED_ENTITY,
  SELECTED_GSTINS,
  SET_ENTITY_LIST,
  SET_MULTIPLE_GSTIN_DATA,
  SET_RECO_HISTORY_TABLE_DATA,
  SET_SUMMARY_DATA,
  STORE_PERIOD,
  TABLE_DATA,
} from "./constants";

export const initialState = {
  loaderStatus: false,
  selectedEntity: "",
  profileData: [],
  selectedGstin: [],
  entityMasterList: [],
  multipleGstinTableData: [],
  summaryTableData: [],
  startDate: null,
  endDate: null,
  selectedPeriodSingle: null,
  isChecked: true,
  tableData: [],
  recoHistoryTableData: [],
  checkedRunFY:false,
  totalPages: 0,
};

const ewbRecoReconcilationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case SET_ENTITY_LIST:
      return {
        ...state,
        entityMasterList: action.payload,
      };
    case PROFILE_DATA:
      return {
        ...state,
        profileData: action.profileData,
      };
    case SELECTED_GSTINS:
      return {
        ...state,
        selectedGstin: action.selectedGstin,
      };
    case SELECTED_ENTITY:
      return {
        ...state,
        selectedEntity: action.data,
      };
    case STORE_PERIOD:
      return {
        ...state,
        startDate: action.date.startDate,
        endDate: action.date.endDate,
      };
    case SET_MULTIPLE_GSTIN_DATA:
      return {
        ...state,
        multipleGstinTableData: action.multipleGstinTableData,
      };
    case SET_SUMMARY_DATA:
      return {
        ...state,
        summaryTableData: action.summaryTableData,
      };
    case TABLE_DATA:
      return {
        ...state,
        tableData: action.tableData,
      };
      case CHECKED_RUN_FY:
        return {
          ...state,
          checkedRunFY: !state.checkedRunFY,
        };
    case SET_RECO_HISTORY_TABLE_DATA:
      return {
        ...state,
        recoHistoryTableData: action.recoHistoryTableData,
      };
    case SAVE_TOTAL_PAGES:
      return {
        ...state,
        totalPages: action.pages,
      };
    default:
      return state;
  }
};

export default ewbRecoReconcilationReducer;
